import api from "../..";
import type { CategoryResponse, PostCategoryParams } from "./types";
import type { ApiResponse } from "../../types";

export const postCategory = async ({ body }: PostCategoryParams): Promise<boolean> => {

  return await api.post<ApiResponse<CategoryResponse>>("/categories/", body)
  .then(() => true)
  .catch(() => false);
};